import { Toaster } from "react-hot-toast";
import AppRoutes from "./routes";

const App = () => (
  <>
    <AppRoutes />
    <Toaster
      position="top-right"
      toastOptions={{
        duration: 3000,
        style: {
          borderRadius: "999px",
          fontSize: "14px",
          fontFamily: "Inter, sans-serif",
        },
        success: {
          style: { background: "#16a34a", color: "#fff" },
          iconTheme: { primary: "#fff", secondary: "#16a34a" },
        },
        error: {
          style: { background: "#dc2626", color: "#fff" },
          iconTheme: { primary: "#fff", secondary: "#dc2626" },
        },
      }}
    />
  </>
);

export default App;
